// largely oauth parameters
const _urlParameterBlacklist = ['token', 'state', 'code'];
const sanitizeUrl = (url) => {
    if (url == null) {
        return url;
    }
    let parsedUrl = null;
    try {
        parsedUrl = new URL(url);
    }
    catch (_a) {
        if (url.startsWith('/')) {
            try {
                parsedUrl = new URL(`${window.location.protocol}//${window.location.host}${url}`);
            }
            catch (_b) {
                // probably not an url
                if (_urlParameterBlacklist.some((u) => url.includes(u))) {
                    return `${url} --- problematic url ?`;
                }
            }
        }
    }
    if (parsedUrl === null) {
        return url;
    }
    _urlParameterBlacklist.forEach((bad) => {
        if (parsedUrl.searchParams.has(bad)) {
            parsedUrl.searchParams.set(bad, '-scrubbed-');
        }
    });
    return parsedUrl.toString();
};
const filterNavigationBreadcrumb = (breadcrumb) => {
    if (breadcrumb.data != null) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        breadcrumb.data['from'] = sanitizeUrl(breadcrumb.data['from']);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        breadcrumb.data['to'] = sanitizeUrl(breadcrumb.data['to']);
    }
    return breadcrumb;
};
const filterBreadcrumbs = (breadcrumbs) => {
    if (!breadcrumbs) {
        return breadcrumbs;
    }
    return breadcrumbs.map((b) => {
        if (b.category === 'navigation') {
            return filterNavigationBreadcrumb(b);
        }
        return b;
    });
};
const filterRequest = (request) => {
    if (!request) {
        return request;
    }
    if (request.url != null) {
        request.url = sanitizeUrl(request.url);
    }
    return request;
};
const isNetworkError = (_, hint) => {
    // https://github.com/getsentry/sentry-javascript/issues/6376#issuecomment-1337616848
    const error = hint.originalException;
    return !!(error instanceof Error &&
        (error.message.match(/Fetch Error/i) ||
            error.message.match(/XHR Error/i) ||
            error.message.match(/adsbygoogle/i) ||
            // Firefox?
            error.message.match(/Network ?Error/i) ||
            // mac
            error.message.match(/Load failed/i) ||
            // chrome
            error.message.match(/Failed to fetch/i)));
};
/**
 * @internal
 */
export const filterMessage = (message, hint) => {
    if (isNetworkError(message, hint)) {
        return null;
    }
    message.breadcrumbs = filterBreadcrumbs(message.breadcrumbs);
    message.request = filterRequest(message.request);
    message.transaction = sanitizeUrl(message.transaction);
    return message;
};
/**
 * @internal
 */
export const filterTransaction = (transaction, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_) => {
    transaction.breadcrumbs = filterBreadcrumbs(transaction.breadcrumbs);
    transaction.request = filterRequest(transaction.request);
    return transaction;
};
//# sourceMappingURL=errorScrubbing.js.map